/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ZandaHealth API
 * OpenAPI spec version: 1.0
 */

export type SlotType = (typeof SlotType)[keyof typeof SlotType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SlotType = {
  Available: 1,
  Class: 2,
  Appointment: 3,
} as const;
